import { render, staticRenderFns } from "./EditStudy.vue?vue&type=template&id=4818ad11&"
import script from "./EditStudy.vue?vue&type=script&lang=js&"
export * from "./EditStudy.vue?vue&type=script&lang=js&"
import style0 from "./EditStudy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports